import { RadioButtonChangeEvent } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';
import { getSortingOptions } from '../../../../../../../../common/global/helpers';
import Dialog from '../../../../../../../../common/widgets/Dialog';
import RadioButton from '../../../../../../../../common/widgets/RadioButton';
import { resources } from '../../../../../../resources/resources';

interface ISortDialogProps {
  order: number;
  isDiscountVoucherList: boolean;
  isBenefitBucksList: boolean;
  isSearchResults: boolean;
  closeDialog: () => void;
  handleSortingOrderChange: (id: number) => void;
  setOrder: (order: number) => void;
}

const SortDialog = (props: ISortDialogProps) => {
  const {
    order,
    isDiscountVoucherList,
    isBenefitBucksList,
    isSearchResults,
    closeDialog,
    handleSortingOrderChange,
    setOrder,
  } = props;
  const { t: translate } = useTranslation();

  const sortingOptions = getSortingOptions(
    isDiscountVoucherList,
    isBenefitBucksList,
    isSearchResults,
  ).map(item => {
    return { id: item.id, text: translate(item.resource) };
  });

  const handleSortChange = (e: RadioButtonChangeEvent) => {
    setOrder(e.value);
    handleSortingOrderChange(e.value);
  };

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      headerContent={
        <div className="dialog-title">
          {translate(resources.searchPage.sort)}
        </div>
      }
      className="dialog-s mobile-sort-dialog"
    >
      <div className="dialog-content mobile-forms">
        {sortingOptions?.map(opt => (
          <RadioButton
            key={opt.id}
            name="sortOptions"
            value={opt.id}
            checked={order === opt.id}
            label={opt.text}
            onChange={handleSortChange}
          />
        ))}
      </div>
    </Dialog>
  );
};

export default SortDialog;
